import {MonoTypeOperatorFunction, take} from 'rxjs';

/** An Alias for rxjs: take(1) */
export function takeOne<T>(): MonoTypeOperatorFunction<T> {
    return take<T>(1);
}
